import axios from "axios";
import { baseURL } from "../utils/consts";

const generateEmailOTP = async (responseUser) => {
  const responseObject = responseUser;
  try {
    const response = await axios.post(
      `${baseURL}/invitedVia/expressEntry/generateEmailOTP`,

      responseObject,

      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.data;
    return data;
  } catch (err) {
    throw err;
  }
};

export default generateEmailOTP;
